export const validateCharacters = function(data)
{
	const re = /^([a-zA-Z ]+)$/;

	return re.test(data);
};

export const validateIntegers = function(data)
{
	const re = /^([0-9]+)$/;

	return re.test(data);
};

export const validateEmail = function(data)
{
	const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;

	return re.test(data);
};

export const validateAlphaNumeric = function(data)
{
	const re = /^([a-zA-Z0-9 ]+)$/;

	return re.test(data);
};

export const validateAlphaNumericSpecial = function(data)
{
	const re = /^[a-zA-Z0-9?=.:*!@#$%^&*_\s()\-[\]]+$/;

	return re.test(data);
};

export const isValidWebsite = (str) =>
{
	const pattern = new RegExp(
		/^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=-]*)?(\?[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=-]*)?$/
	);

	return pattern.test(str);
};